import InvoicesService from "@/api/services/invoices";
import { toCamelCase } from "@/utils/utils";

const initialState = {
  index: [],
  totalCount: null,
  totalPages: null,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },

    getTotalCount(state) {
      return state.totalCount;
    },

    getTotalPages(state) {
      return state.totalPages;
    },

    // Full class names (not built by concatenation) so Tailwind keeps them.
    getPaymentStatusStyle: () => (paymentStatus) => {
      switch (paymentStatus) {
        case "pending_payment":
          return { badge: "bg-yellow-50 text-yellow-800 ring-yellow-200", dot: "bg-yellow-500" };
        case "paid":
          return { badge: "bg-green-50 text-green-800 ring-green-200", dot: "bg-green-500" };
        case "processing":
          return { badge: "bg-indigo-50 text-indigo-800 ring-indigo-200", dot: "bg-indigo-500" };
        case "not_payable":
          return { badge: "bg-gray-50 text-gray-600 ring-gray-200", dot: "bg-gray-400" };
        default:
          return { badge: "bg-blue-50 text-blue-800 ring-blue-200", dot: "bg-blue-500" };
      }
    },

    getTransactionTypeStyle: () => (transactionType) => {
      return transactionType === "bill"
        ? "text-sky-800 bg-sky-50 ring-sky-200"
        : "text-gray-700 bg-gray-50 ring-gray-200";
    },

    getPaymentStatuses: () => () => {
      return ["pending_payment", "paid", "symbolic_invoice", "processing", "not_payable"];
    },

    getTransactionTypes: () => () => {
      return ["bill", "statement"];
    },

    getMandateStatuses: () => () => {
      return ["signed", "sent", "not_signed"];
    },
  },
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
    setTotalCount(state, totalCount) {
      state.totalCount = totalCount;
    },
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages;
    },
  },

  actions: {
    async fetchIndex(
      { commit },
      {
        page,
        organizations,
        stores,
        billingEntities,
        paymentStatuses,
        transactionTypes,
        mandateStatuses,
        withSubjectUnpaidBill,
        paymentStartDate,
        paymentEndDate,
      },
    ) {
      const response = await InvoicesService.fetchIndex({
        page,
        organizations,
        stores,
        billingEntities,
        paymentStatuses,
        transactionTypes,
        mandateStatuses,
        withSubjectUnpaidBill,
        paymentStartDate,
        paymentEndDate,
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data.invoices);
      commit("setTotalCount", data.page.totalCount);
      commit("setTotalPages", data.page.totalPages);

      return response;
    },

    async fetchSummary() {
      const response = await InvoicesService.fetchSummary();
      if (!response?.success) return null;

      return toCamelCase(response.data);
    },

    async markInvoicesAsPaid(_, invoiceIds) {
      return await InvoicesService.markAsPaid(invoiceIds);
    },

    async sendInvoicesReport(_, { email, paymentStartDate, paymentEndDate }) {
      return await InvoicesService.sendReport({ email, paymentStartDate, paymentEndDate });
    },

    async downloadInvoicesQontoBulkTransferCSV(_, { startDate, endDate }) {
      return await InvoicesService.downloadQontoBulkTransferCSV({ startDate, endDate });
    },
  },
};
